import React from 'react';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import IconButton from 'material-ui/IconButton';
import KeyboardArrowUp from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import TextField from 'material-ui/TextField';

import * as Queries from '../../queries';
import * as Actions from '../../actions';

import Categories from './Categories';
import MenuItems from './MenuItems';

class Menu extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchText: ''
        };
    }

    componentDidMount() {
        if (!this.props.menu)
            this.refreshMenu();
    }

    render() {
        const {
            menu,
            ticket,
            disabled = false,
            onMenuItemClick = () => { },
            toggleQuantityPad
        } = this.props;

        const filteredMenuItems = this.getFilteredMenuItems();
        const selectedTableName = this.getSelectedTableName(ticket);

        return (
            <Paper className='menu'>
                <Categories
                    categories={menu ? menu.categories : undefined}
                    onClick={this.onCategoryClick}
                />

                <div className='menuRight'>
                    <div className='menuSearchWrapper'>
                        <div className='menuSearchInputWrapper'>
                            <TextField
                                fullWidth={true}
                                hintText='Ürün ara...'
                                value={this.state.searchText}
                                onChange={this.onSearchChange}
                                className='menuSearchInput'
                            />
                        </div>
                        {selectedTableName &&
                            <div className='menuSelectedTable' title={selectedTableName}>
                                {selectedTableName}
                            </div>
                        }
                    </div>

                    <div className='menuItemsWrapper'>
                        <MenuItems
                            menuItems={filteredMenuItems}
                            disabled={disabled}
                            onClick={this.onMenuItemClickInternal}
                        />
                    </div>

                    <div className='quantityPadToggleBar'>
                        <IconButton onClick={toggleQuantityPad}>
                            <KeyboardArrowUp />
                        </IconButton>
                    </div>
                </div>
            </Paper>
        );
    }

    refreshMenu() {
        Queries.getMenu((menu) => {
            Queries.getOrderTagColors((colors) => {
                var result = colors.reduce(function (map, obj) {
                    map[obj.name] = obj.value;
                    return map;
                }, {});
                this.props.setOrderTagColors(result);
            });

            this.props.setMenu(menu);

            if (menu.categories[0])
                this.onCategoryClick(menu.categories[0].name);
        });
    }

    onCategoryClick = (category) => {
        this.props.changeSelectedCategory(category);
        this.props.closeMessage();
        this.refreshMenuItems(category);
    }

    refreshMenuItems(category) {
        var categories = this.props.menu.categories;
        var c = categories.find(x => x.name === category);
        this.props.setMenuItems(c.menuItems);
    }

    onSearchChange = (event, value) => {
        this.setState({ searchText: value });
    }

    onMenuItemClickInternal = (productId, orderTags = '', automationCommand = '') => {
        this.setState({ searchText: '' });
        this.props.onMenuItemClick(productId, orderTags, automationCommand);
    }

    getFilteredMenuItems() {
        const { menu, menuItems } = this.props;
        const searchText = (this.state.searchText || '').trim().toLowerCase();

        if (!searchText) {
            return menuItems || [];
        }

        if (!menu || !menu.categories) {
            return [];
        }

        let allItems = [];

        menu.categories.forEach(category => {
            if (category.menuItems && category.menuItems.length) {
                allItems = allItems.concat(category.menuItems);
            }
        });

        return allItems.filter(item => {
            const itemName = (item.name || '').toLowerCase();
            return itemName.indexOf(searchText) > -1;
        });
    }

    getSelectedTableName(ticket) {
        if (!ticket || !ticket.entities) {
            return '';
        }

        const tableEntity = ticket.entities.find(x => x && x.type === 'Masalar');
        return tableEntity && tableEntity.name ? String(tableEntity.name).trim() : '';
    }
}

const mapStateToProps = state => ({
    menu: state.menu.get('menu'),
    menuItems: state.menu.get('menuItems')
});

const mapDispatchToProps = ({
    changeSelectedCategory: Actions.changeSelectedCategory,
    setOrderTagColors: Actions.setOrderTagColors,
    setMenu: Actions.setMenu,
    setMenuItems: Actions.setMenuItems,
    closeMessage: Actions.closeMessage
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Menu);



// WEBPACK FOOTER //
// ./app/components/Menu/Menu.jsx